import { TrialEndedModal } from "@/components/trial-ended-modal";
import { companyQueryOptions } from "@/lib/query-options";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

// Prevent access to this company if the user is not a member.
export const Route = createFileRoute("/(dashboard)/_authenticated/$companyId")({
  beforeLoad: async ({ context, params }) => {
    try {
      const company = await context.queryClient.ensureQueryData(
        companyQueryOptions(params.companyId),
      );

      if (!company) {
        throw new Error("Empresa no encontrada");
      }
    } catch (error) {
      throw redirect({
        to: "/",
      });
    }
  },
  component: LayoutComponent,
});

function LayoutComponent() {
  return (
    <>
      <Outlet />
      <TrialEndedModal />
    </>
  );
}
